import { findIndex } from 'lodash';
import { FetchResult } from 'apollo-link';
import { DataProxy } from 'apollo-cache';

import { GetUserSearchesV2Document, QueryGetUserSearchesV2Args, UserProfile } from 'api';

interface IReducer {
  cache: DataProxy;
  result: FetchResult;
  variables: QueryGetUserSearchesV2Args;
}

export const batchUpdateUserStatus = (options: IReducer) => {
  const { cache, result, variables } = options;
  const { getProfilesByUserStatus, search } = cache.readQuery({
    query: GetUserSearchesV2Document,
    variables,
  });

  if (!getProfilesByUserStatus && !search) {
    return;
  }

  const profilesKey = getProfilesByUserStatus && getProfilesByUserStatus.profiles;
  const searchKey = search && search.results;
  const activeResultsKey = profilesKey || searchKey;

  const { batchUpdateUserProfileStatus } = result.data;

  batchUpdateUserProfileStatus.forEach(({ id }: UserProfile) => {
    const index = findIndex(activeResultsKey, { id });
    activeResultsKey.splice(index, 1);
  });

  cache.writeQuery({
    query: GetUserSearchesV2Document,
    variables,
    data: { getProfilesByUserStatus, search },
  });
};

export const batchUpdateUserType = (options: IReducer) => {
  const { cache, result, variables } = options;
  const { getProfilesByUserStatus, search } = cache.readQuery({
    query: GetUserSearchesV2Document,
    variables,
  });

  if (!getProfilesByUserStatus && !search) {
    return;
  }

  const profilesKey = getProfilesByUserStatus && getProfilesByUserStatus.profiles;
  const searchKey = search && search.results;
  const activeResultsKey = profilesKey || searchKey;

  const { batchUpdateUserProfileUserType } = result.data;

  batchUpdateUserProfileUserType.forEach(({ id, user_type }: UserProfile) => {
    const index = findIndex(activeResultsKey, { id });
    activeResultsKey[index].user_type = user_type;
  });

  cache.writeQuery({
    query: GetUserSearchesV2Document,
    variables,
    data: { search, getProfilesByUserStatus },
  });
};
